<template>
  <div id="app">
    <skeleton-normal v-if="(!loginComplete && !failComplete) || false"></skeleton-normal>
    <template v-else-if="loginComplete">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </template>
    <default-page v-else-if="failComplete"></default-page>
    <mt-tabbar v-model="selected" v-if="loginComplete && isShowNav">
      <mt-tab-item id="souhuo" @click.native="changeTab('souhuo')">
        <img slot="icon" src="./assets/icon/sh_home_on.png" v-show="selected === 'souhuo'" />
        <img slot="icon" src="./assets/icon/sh_home.png" v-show="selected !== 'souhuo'" />
        首页
      </mt-tab-item>
      <!-- <mt-tab-item id="onePackage" @click.native="changeTab('onePackage')">
        <img slot="icon" src="./assets/icon/car_on.png" v-show="selected === 'onePackage'">
        <img slot="icon" src="./assets/icon/car.png" v-show="selected !== 'onePackage'">
        9.9包邮
      </mt-tab-item> -->
      <mt-tab-item id="unSearchCenter" @click.native="changeTab('unSearchCenter')">
        <img slot="icon" src="./assets/icon/un_search_on.png" v-show="selected === 'unSearchCenter'" />
        <img slot="icon" src="./assets/icon/un_search.png" v-show="selected !== 'unSearchCenter'" />
        补贴专区
      </mt-tab-item>
      <mt-tab-item id="zeroBuyMain" @click.native="changeTab('zeroBuyMain')">
        <img slot="icon" src="./assets/icon/zero_on.png" v-show="selected === 'zeroBuyMain'" />
        <img slot="icon" src="./assets/icon/zero.png" v-show="selected !== 'zeroBuyMain'" />
        0元专区
        <div class="home-badge home-badge-zero" v-if="getTabBarZeroBadge.WaitGetFreeCardNum > 0">
          <soho-badge :number="getTabBarZeroBadge.WaitGetFreeCardNum"></soho-badge>
        </div>
      </mt-tab-item>
      <mt-tab-item id="collectionClip" @click.native="changeTab('collectionClip')">
        <img slot="icon" src="./assets/icon/collection_on.png" v-show="selected === 'collectionClip'" />
        <img slot="icon" src="./assets/icon/collection.png" v-show="selected !== 'collectionClip'" />
        {{ getIsApp ? '收藏/提醒' : '收藏夹' }}
      </mt-tab-item>
      <mt-tab-item id="my" @click.native="changeTab('my')">
        <img slot="icon" src="./assets/icon/sh_my_on.png" v-show="selected === 'my'" />
        <img slot="icon" src="./assets/icon/sh_my.png" v-show="selected !== 'my'" />
        我的
        <div class="home-badge" v-if="getTabBarMyBadge > 0">
          <soho-badge :number="getTabBarMyBadge"></soho-badge>
        </div>
      </mt-tab-item>
    </mt-tabbar>
    <!-- tab切换时弹出 -->
    <login-dialog v-if="getLoginDialogShow" @close="LOGINDIALOG_SHOW(false)"> </login-dialog>
    <!-- 授权弹窗 -->
    <authorize-popup v-if="getAuthorizePopupShow" @close="AUTHORIZE_POPUP_SHOW(false)"></authorize-popup>
    <!-- 屏蔽商品原因 -->
    <shield-dialog v-if="getShieldDialogShow" @close="SHIELD_DIALOG_SHOW(false)"> </shield-dialog>
    <!-- 如何搜索弹窗 -->
    <qrcode-popup></qrcode-popup>
    <!-- 引导评价弹窗 -->
    <guide-evaluation-popup></guide-evaluation-popup>
    <!-- 权限描述弹窗 -->
    <permission-desc-popup></permission-desc-popup>
    <!-- 引导到app弹窗 -->
    <guide-to-app-popup></guide-to-app-popup>
  </div>
</template>

<script>
import baseUtil from './utils/base'
import { PROCESS_ENV, BASE_HREF, SHARE_URL } from './config/index'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { MessageBox, Indicator } from 'mint-ui'
import DefaultPage from '@/components/DefaultPage'
import { checkLogin, SAppShortInfo, AuthCfg } from '@/api/login'
import LoginDialog from '@/components/smartComponent/LoginDialog'
import ShieldDialog from '@/components/puppetComponent/ShieldDialog'
import AuthorizePopup from '@/components/smartComponent/AuthorizePopup'
import SkeletonNormal from './components/common/Skeleton/SkeletonNormal'
import QrcodePopup from './components/common/QrcodePopup/QrcodePopup'
import GuideEvaluationPopup from './components/common/GuideEvaluationPopup/GuideEvaluationPopup'
import PermissionDescPopup from './components/common/PermissionDescPopup/Index.vue'
import GuideToAppPopup from './components/common/GuideToAppPopup/Index.vue'

export default {
  data() {
    return {
      selected: 'souhuo',
      loginComplete: false,
      failComplete: false,
      isShowNav: false,
      navBarData: {
        isShowNavTab: true,
        title: ''
      }
    }
  },
  components: {
    DefaultPage,
    LoginDialog,
    ShieldDialog,
    AuthorizePopup,
    SkeletonNormal,
    QrcodePopup,
    GuideEvaluationPopup,
    PermissionDescPopup,
    GuideToAppPopup
  },
  async created() {
    // 判断是否是 app start
    let isApp = baseUtil.getUrlKey('isApp') ? baseUtil.getUrlKey('isApp') : false
    this.SET_IS_APP(isApp) // 新增存储是否是通过uniapp访问的参数
    if (isApp) {
      this.appExecute()
      return
    }
    // 判断是否是 app end
    let urlKey = baseUtil.getUrlKey('debugKey')
    // 调试错误日志记录(仅开发调试用)
    if (urlKey) {
      baseUtil.debugLogin(this, Indicator)
      return
    }
    // 部分安卓微信浏览器无法跳转相同链接的 window.location.href ，在链接后加入随机数
    let baseHrefRandom = ''
    if (PROCESS_ENV === 'production') baseHrefRandom = '?time=' + new Date().getTime()
    Indicator.open({
      text: '加载中',
      spinnerType: 'triple-bounce'
    })
    let sessionId = this.$store.getters.sessionId
    let redirectRouter = baseUtil.getUrlKey('redirectRouter')
    let trackEvent = baseUtil.getUrlKey('trackEvent')
    if (trackEvent) {
      if (trackEvent === 'soho2018') {
        window._hmt.push(['_trackEvent', 'ad', 'ad-entry', 'tencent'])
      }
    }
    // sessionId存在表示已登陆过，页面被重新刷新
    if (sessionId) {
      checkLogin().then((res) => {
        if (res.isLogin) {
          this.fetchShortInfo(() => {
            this.loginComplete = true
            setTimeout(Indicator.close, 300)
            this.urlRedirect(redirectRouter)
          })
        } else {
          this.loginOut().then(() => {
            window.location.href = BASE_HREF + baseHrefRandom
          })
        }
      })
    } else {
      let code = baseUtil.getUrlKey('code')
      let getWechatCode = baseUtil.getUrlKey('getWechatCode')
      // code存在时表示微信进入，否则返回微信授权链接
      if (code) {
        if (getWechatCode === 'soho2018') return
        // 登陆api
        this.loginMode(code)
          .then(async () => {
            this.loginComplete = true
            this.urlRedirect(redirectRouter)
          })
          .catch((err) => {
            if (PROCESS_ENV === 'production') {
              this.loginOut().then(() => {
                window.location.href = BASE_HREF + baseHrefRandom
              })
            } else {
              this.failComplete = true
              MessageBox('提示', err)
            }
          })
          .then(() => {
            Indicator.close()
          })
      } else {
        await this.loginOut()
        if (redirectRouter) {
          // 从分享页进来时，微信会给分享的链接添加一些后缀，所以进来时，需要将后缀截掉，否则无法跳转到相应的页面
          let link = `${SHARE_URL}/?${window.location.href.split('?')[1].split('&')[0]}`
          let encodeLink = encodeURIComponent(link)
          window.location.href =
            'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxaa3a999db5d744c6&redirect_uri=' +
            encodeLink +
            '&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect' +
            baseHrefRandom
        } else {
          window.location.href = BASE_HREF + baseHrefRandom
        }
      }
    }
  },
  mounted() {
    this.updateNavShow()
    this.$nextTick(() => {
      // 监听resize方法
      window.addEventListener('resize', this.renderResize, false)
    })
  },

  beforeDestroy() {
    // 移除监听
    window.removeEventListener('resize', this.renderResize, false)
  },
  computed: {
    ...mapGetters([
      'loginState',
      'getIsApp',
      'getIsAuthorized',
      'getTabBarMyBadge',
      'getTabBarZeroBadge',
      'getTabBarShow',
      'getLoginDialogShow',
      'getAuthorizePopupShow',
      'getQrCodeIsShow',
      'getShieldDialogShow',
      'getIosIsShowLoginBtn'
    ])
  },
  methods: {
    ...mapMutations([
      'LOGINDIALOG_SHOW',
      'AUTHORIZE_POPUP_SHOW',
      'SHIELD_DIALOG_SHOW',
      'SET_IS_APP',
      'RECEIVE_SESSION_ID',
      'RECEIVE_LOGIN_STATE',
      'SET_PERMISSION_DESC_POPUP_INFO',
      'SET_IS_AUTHORIZED',
      'SET_VERSION_CODE',
      'SET_IOS_IS_SHOW_LOGIN_BTN',
      'SET_IS_HAVE_UNFINISHED_ORDER',
      'SET_IS_HORIZONTAL_SCREEN',
      'SET_NOTIFICATION_AUTHORIZED'
    ]),
    ...mapActions(['loginMode', 'loginOut']),
    // 封装只有app才会执行的逻辑
    appExecute() {
      // app导航栏触发返回按钮
      window.navigatorBackHandler = () => {
        this.$router.go(-1)
      }
      // app授权登录成功
      window.isAuthorized = (data) => {
        this.RECEIVE_SESSION_ID(data)
        this.SET_IS_AUTHORIZED(true)
      }
      // 当前app版本
      window.setVersion = (data) => {
        this.SET_VERSION_CODE(data)
      }
      // app登录状态
      window.receiveLoginState = (data) => {
        this.RECEIVE_LOGIN_STATE(JSON.parse(data))
        // 假如没有登录的话弹窗绑定弹窗
        if (!JSON.parse(data)) {
          this.LOGINDIALOG_SHOW(true)
        } else {
          this.app_refreshFlag()
        }
      }

      // 跳转路由
      window.routerPushSwitchHandler = (data) => {
        const [name, params] = data.split('?')

        if (params) {
          const paramsArray = params.split('&')
          const paramsObj = {}
          paramsArray.forEach((param) => {
            const [key, value] = param.split('=')
            paramsObj[key] = value
          })
          this.$router.push({
            name,
            query: paramsObj
          })
          return
        }
        this.$router.push({
          name
        })
      }

      // 权限描述
      window.showPermissionDescPopup = (data) => {
        // this.$uni.postMessage({
        //   data: {
        //     consoleLogHandler: true,
        //     log: data
        //   }
        // })
        this.SET_PERMISSION_DESC_POPUP_INFO(JSON.parse(JSON.stringify(data)))
      }

      window.returnUpdateNotificationAuthorized = (data) => {
        this.SET_NOTIFICATION_AUTHORIZED(JSON.parse(data))
      }

      // app需刷新
      this.$EventBus.$on('h5_register_success', () => {
        this.app_refreshFlag()
      })
      // 存储token
      let appTokenId = baseUtil.getUrlKey('appTokenId') ? baseUtil.getUrlKey('appTokenId') : ''
      if (appTokenId) {
        this.RECEIVE_SESSION_ID(appTokenId)
      }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      // 统计的代码
      let trackEvent = baseUtil.getUrlKey('trackEvent')
      if (trackEvent) {
        if (trackEvent === 'soho2018') {
          window._hmt.push(['_trackEvent', 'ad', 'ad-entry', 'tencent'])
        }
      }
      let redirectRouter = baseUtil.getUrlKey('redirectRouter')
      checkLogin().then(async (res) => {
        if (res.isLogin) {
          this.RECEIVE_LOGIN_STATE(res.isLogin)
          this.fetchShortInfo(() => {
            this.loginComplete = true
            setTimeout(Indicator.close, 300)
            // this.urlRedirect(redirectRouter)
          })
        } else {
          if (baseUtil.isIOS()) await this.getIosAuthCfg()
          this.RECEIVE_LOGIN_STATE(res.isLogin)
          this.loginComplete = true
          // 是否新人。
          baseUtil.setNewcomerStorage(true)
          // this.urlRedirect(redirectRouter)
        }
        this.urlRedirect(redirectRouter)
      })
    },
    // app刷新事件
    app_refreshFlag() {
      this.fetchShortInfo(() => {
        // app登录之后，全局通知刷新页面
        this.$EventBus.$emit('app_refreshFlag')
      })
    },
    updateNavShow() {
      let routeName = this.$route.name
      let tabRouters = ['souhuo', 'unSearchCenter', 'zeroBuyMain', 'collectionClip', 'my']
      if (tabRouters.indexOf(routeName) !== -1 || !routeName) {
        this.isShowNav = true
        this.selected = routeName
      } else {
        this.isShowNav = false
      }
    },
    changeTab(id) {
      if (id === 'collectionClip' && !this.loginState) {
        this.selected = this.$route.name
        this.unLoginModal()
        return
      }
      if (id !== this.$route.name) {
        this.$router.replace(id)
      }
    },
    urlRedirect(routerName) {
      if (routerName) {
        let routerArray = routerName.split(',')
        let queryObj = {}
        if (routerArray.length > 1) {
          for (let i = 1; i < routerArray.length; i = i + 2) {
            queryObj[routerArray[i]] = routerArray[i + 1]
          }
        }
        this.$router.push({
          name: routerArray[0],
          query: queryObj
        })
      }
    },
    // 有些手机浏览器关闭后sessionStorage的数据还是会缓存，导致tokenid还会缓存在本地。
    // 所以这里再次获取用户订单是否完成以及是否关注公众号
    fetchShortInfo(fn) {
      SAppShortInfo()
        .then((res) => {
          // 是否有未完成的订单
          // setStore("HAVE_UNFINISHED_ORDER", res.Data.hasOrder);
          this.SET_IS_HAVE_UNFINISHED_ORDER(res.Data.hasOrder)
          // 是否新人。isNewPerson 为true时，storage会设置值，false或其他假值则相应的storage会自动删除
          baseUtil.setNewcomerStorage(res.Data.isNewPerson)
          baseUtil.setIsZeroHideScoreStorage(res.Data.isZeroHideScore)
          fn()
        })
        .catch((err) => {
          MessageBox('提示', err.ErrMsg || '请求出错')
        })
    },
    // 授权弹窗获取是否展现苹果授权登陆入口
    getIosAuthCfg() {
      return new Promise((resolve) => {
        AuthCfg().then((res) => {
          this.SET_IOS_IS_SHOW_LOGIN_BTN(res.Data)
          resolve()
        })
      })
    },
    unLoginModal() {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true)
        return
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit('LOGINDIALOG_SHOW', true)
        return
      }
      this.LOGINDIALOG_SHOW(true)
    },
    isShowNavTabHandler() {
      let filterRouterList = ['souhuo', 'unSearchCenter', 'zeroBuyMain', 'collectionClip', 'my']
      if (filterRouterList.includes(this.$route.name)) {
        this.navBarData.isShowNavTab = false
        this.postMessageHandler({
          showTabBar: false
        })
      } else {
        this.navBarData.isShowNavTab = true
        this.postMessageHandler({
          showTabBar: true
        })
        let tempTitle = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : ''
        this.navBarData.title = tempTitle
      }
    },
    postMessageHandler(data) {
      this.$nextTick(function() {
        if (this.$uni) {
          this.$uni.postMessage({
            data: data
          })
        } else {
          let _this = this
          document.addEventListener('UniAppJSBridgeReady', function() {
            _this.$uni = window.uni
            _this.$uni.postMessage({
              data: data
            })
          })
        }
      })
    },
    // 是否展示授权弹窗
    handlerIsShowAuthorizePopup({ to = '', from = '' }) {
      this.AUTHORIZE_POPUP_SHOW(false)
      this.LOGINDIALOG_SHOW(false)
      // 协议路由
      let agreementRouterList = ['privacyAgreement', 'userAgreement']
      // 协议页面返回，不需要弹出授权弹窗
      let dontNeedToShowAuthorizePopupRouterList = ['privacyAgreement', 'userAgreement', 'aboutUs', 'register']
      if (!this.loginState && agreementRouterList.indexOf(from.name) !== -1 && dontNeedToShowAuthorizePopupRouterList.indexOf(to.name) < 0) {
        if (this.getIsApp && !this.getIsAuthorized) {
          this.AUTHORIZE_POPUP_SHOW(true)
        } else if (!this.loginState) {
          this.LOGINDIALOG_SHOW(true)
        }
      }
    },
    renderResize() {
      // 判断横竖屏
      let width = document.documentElement.clientWidth
      let height = document.documentElement.clientHeight
      if (width > height) {
        this.SET_IS_HORIZONTAL_SCREEN(true)
      } else {
        this.SET_IS_HORIZONTAL_SCREEN(false)
      }
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        this.handlerIsShowAuthorizePopup({ to: to, from: from })
        this.updateNavShow()
        if (this.getIsApp) this.isShowNavTabHandler()
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true
    },
    getTabBarShow() {
      let routeName = this.$route.name
      if (this.getTabBarShow && (routeName === 'souhuo' || routeName === 'unSearchCenter')) {
        this.isShowNav = true
      } else {
        this.isShowNav = false
      }
    }
  }
}
</script>

<style lang="scss">
@import './style/reset.css';
@import './style/public.scss';
@import './style/font/iconfont.css';
.mint-tabbar {
  position: fixed;
  background-image: none;
  box-shadow: 0 0 10px 0 hsla(0, 2%, 75%, 0.5);
  z-index: 1000;
}
.home-badge {
  position: absolute;
  top: 10%;
  right: 3%;
}
.home-badge-zero {
  right: 42%;
}
.mint-tab-item {
  padding: 8px 0;
  color: #888;
}
.mint-tab-item.is-selected {
  background: transparent;
  color: #000 !important;
}
</style>
